import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"

export interface ICoupomV2 {
  id: string
  _id: string
  code: string // código único do cupom
  remaining_uses: number // Quantos usos possíveis
  expiration_date: string | Date
  discount_valid_until_date: string
  name: string
  resources: {
    operators: {
      discount: number
    }
    channels: {
      [channelName: string]: {
        discount: number
      }
    }
    sms: {
      price: number
    }
  }
}

export const couponsV2: IGenericModel<ICoupomV2> = {
  ...generic(endpoints.ADMIN_COUPONS_V2),
}
